interface StyledListProps extends React.HTMLAttributes<HTMLUListElement | HTMLOListElement> {
  ordered?: boolean;
  children?: React.ReactNode;
}
const StyledList: React.FC<StyledListProps> = ({
  ordered,
  children,
  ...props
}) => {
  const ListTag = ordered ? 'ol' : 'ul';
  return <ListTag ref={node => {
    if (node && !ordered) {
      const prevSibling = node.previousElementSibling;
      if (prevSibling && prevSibling.tagName.toLowerCase() === 'ol') {
        node.classList.remove('pl-5');
        node.classList.add('pl-10');
      }
    }
  }} className="box-border p-0 pl-5 m-0 mb-2" {...props} data-sentry-element="ListTag" data-sentry-component="StyledList" data-sentry-source-file="styledListMarkdown.tsx">
      {children}
    </ListTag>;
};
const StyledListItem: React.FC<React.LiHTMLAttributes<HTMLLIElement>> = ({
  children,
  ...props
}) => <li className="text-white font-light text-[14px] leading-snug m-0 p-0 mb-2 ml-3 pb-[1px] last:mb-0" {...props} data-sentry-component="StyledListItem" data-sentry-source-file="styledListMarkdown.tsx">{children}</li>;
export { StyledList, StyledListItem };